import { render, staticRenderFns } from "./SerumIngredientColorBox.vue?vue&type=template&id=8c1f8612&scoped=true&"
import script from "./SerumIngredientColorBox.vue?vue&type=script&lang=js&"
export * from "./SerumIngredientColorBox.vue?vue&type=script&lang=js&"
import style0 from "./SerumIngredientColorBox.vue?vue&type=style&index=0&id=8c1f8612&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c1f8612",
  null
  
)

export default component.exports